import React, { useRef, useState } from 'react';
import { LuMoveHorizontal } from 'react-icons/lu';
import './BeforeAfterHero.scss';

const skylineWidths = [640, 1280, 1920, 2560, 3840, 6016];
const skylineSources = image => skylineWidths
    .map(width => `/images/skyline/${image}-${width}.webp ${width}w`)
    .join(', ');

export default function BeforeAfterHero() {
    const [position, setPosition] = useState(50);
    const [hasInteracted, setHasInteracted] = useState(false);
    // Position before a touch gesture, restored if the browser turns the gesture into a vertical scroll.
    const touchStartPosition = useRef(null);

    const onPointerDown = event => {
        setHasInteracted(true);
        touchStartPosition.current = event.pointerType === 'touch' ? position : null;
    };
    const onPointerCancel = () => {
        if (touchStartPosition.current !== null) setPosition(touchStartPosition.current);
        touchStartPosition.current = null;
    };

    return (
        <div className={`skyline-comparison${hasInteracted ? ' is-touched' : ''}`}
             style={{ '--comparison-position': `${position}%` }}>
            <picture>
                <source type="image/webp" srcSet={skylineSources('citynight')} sizes="100vw" />
                <img className="skyline-image" src="/citynight.jpg" alt="Calgary skyline at night"
                     width="6016" height="4016" draggable="false" fetchpriority="high" />
            </picture>
            <picture>
                <source type="image/webp" srcSet={skylineSources('cityday')} sizes="100vw" />
                <img className="skyline-image skyline-day" src="/cityday.jpg" alt="Calgary skyline by day"
                     width="6016" height="4016" draggable="false" fetchpriority="high" />
            </picture>
            <div className="skyline-divider" aria-hidden="true" />
            <input className="skyline-range" type="range" min="0" max="100" value={position}
                   aria-label="Compare Calgary by day and night"
                   aria-valuetext={`${position}% day, ${100 - position}% night`}
                   onChange={event => setPosition(Number(event.target.value))}
                   onKeyDown={() => setHasInteracted(true)}
                   onPointerDown={onPointerDown}
                   onPointerUp={() => { touchStartPosition.current = null; }}
                   onPointerCancel={onPointerCancel} />
            <span className="skyline-handle" aria-hidden="true"><LuMoveHorizontal /></span>
        </div>
    );
}
